module.exports = __webpack_public_path__ + "static/img/kx1-1.bbb3a34.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kx1-1.png
// module id = 748
// module chunks = 0